export const DateFormat = (d,mask) => {
	const now = new Date(d)
	return mask.replace(/(mm)|(m)|(dd)|(d)|(yyyy)|(yy)/g,(x)=>{
		const right = (s,n) => s.substring(s.length-n,s.length)
		const fns = {
			m: ()=>now.getMonth()+1,
			d: ()=>now.getDate(),
			y: ()=>now.getFullYear()
		}
		return right("0"+fns[x.substring(0,1)](),x.length)
	})
}

export const Comma = n => n.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1,')

export const Money = n => "$"+Comma(n.toFixed(2))

export const Bool = s => !!parseFloat(s) || /^(true|yes)$/ig.test(s)

export const Equal = (a,b) => JSON.stringify(a) === JSON.stringify(b)

export const Members = (a1,a2)=> a1.filter((x)=>a2.indexOf(x)>-1)

export const _Members = (a1,a2)=> a1.filter((x)=>a2.indexOf(x)<0)


// WEBPACK FOOTER //
// ./src/Utils/index.js